import { Pipe, PipeTransform } from '@angular/core';

import { diasSemanas } from '../../../models';

@Pipe({
    name: 'diaSemana'
})
export class DiaSemanaPipe implements PipeTransform {
    transform(value: number): string {
        if (isNaN(value) || value < 0) {
            return '';
        }

        const index = diasSemanas.findIndex(diaSemana => diaSemana.dia === value);
        if (index > -1) {
            return diasSemanas[index].nome;
        }
        return '';
    }
}
